import { expressQuerySelector } from "../../common/html";
import { createGeneralPageEventsAndComponents } from "../technical/page-general";

window.addEventListener("DOMContentLoaded", async () => {
	const generalPageComponents = createGeneralPageEventsAndComponents();
	generalPageComponents.disableLeaveIntent();

	const popupEl = expressQuerySelector<HTMLElement>(document, ".technical-locatephotos-popup", false);
	if (!popupEl) return;

	const mediaStorePartnerName = popupEl.dataset.mediastorepartnername || "";
	const mediaStorePartnerType = parseInt(popupEl.dataset.mediastoretype || "0", 10);
	const iscommingfrompartnerauthentication = popupEl.dataset.iscommingfrompartnerauthentication === "true";
	const loggedin = popupEl.dataset.loggedin === "true";

	if (loggedin) {
		const bc = new BroadcastChannel("connectedToStorePartner");
		bc.postMessage({ command: "connectedToStorePartner", storeType: mediaStorePartnerType });
		bc.close();

		if (window.opener && window.opener.ClosePartnerWindow) {
			window.opener.ClosePartnerWindow();
		} else {
			window.open("", "_self", "");
			window.close();
		}
	} else if (iscommingfrompartnerauthentication) {
		if (window.opener && window.opener.PartnerAuthenticationCompleted) {
			window.opener.PartnerAuthenticationCompleted(mediaStorePartnerName, false);
		} else {
			window.open("", "_self", "");
			window.close();
		}
	}
});
